import { createTheme, ThemeOptions } from '@material-ui/core';
import * as R from 'ramda';

import cssColors from 'assets/colors.scss';
/* eslint-disable @typescript-eslint/camelcase */

const CONTRAST_THRESHOLD = 4.5;

const {
  palette: { augmentColor },
} = createTheme({
  palette: {
    contrastThreshold: CONTRAST_THRESHOLD,
  },
});

const theme: ThemeOptions = {
  palette: {
    ...R.map((main: string) => augmentColor({ main }))(cssColors),
    contrastThreshold: CONTRAST_THRESHOLD,
  },
  typography: {
    fontFamily: ['foobar_m3', 'Proxima Nova', 'Arial', 'sans-serif'].join(','),
    fontSize: 14,
    button: {
      textTransform: 'none',
      fontWeight: 600,
      fontSize: '1rem',
    },
    body2: {
      fontSize: '1rem',
    },
    caption: { fontSize: '0.875rem' },
  },
  overrides: {
    MuiButtonBase: {
      root: {
        '&:focus': { outline: 'none !important' },
      },
    },
    MuiMenuItem: {
      root: {
        whiteSpace: 'normal',
      },
    },
  },
  props: {
    MuiBadge: {
      overlap: 'rectangular',
    },
  },
};
export const lightTheme = createTheme(theme);
export const darkTheme = createTheme(
  R.assocPath(['palette', 'type'], 'dark', theme),
);
